// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages-help-__slug-indexstyleGrid-container-bkkib{margin:0 auto;max-width:1536px;padding:0 12px;width:100%}.pages-help-__slug-indexstyleGrid-grid-bmpvb{display:grid;grid-gap:24px;grid-template-columns:repeat(12,1fr)}.pages-help-__slug-indexstyleGrid-col6-bbwsx{grid-column:span 6}.pages-help-__slug-indexstyleGrid-col3-wortr{grid-column:span 3}.pages-help-__slug-indexstyleGrid-col4-bhnjv{grid-column:span 4}.pages-help-__slug-indexstyleGrid-col9-treia{grid-column:span 9}.pages-help-__slug-indexstyleGrid-col12-bruyl{grid-column:span 12}.pages-help-__slug-indexstyleGrid-alignItemsStart-bgrud{align-items:start}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "pages-help-__slug-indexstyleGrid-container-bkkib",
	"grid": "pages-help-__slug-indexstyleGrid-grid-bmpvb",
	"col6": "pages-help-__slug-indexstyleGrid-col6-bbwsx",
	"col3": "pages-help-__slug-indexstyleGrid-col3-wortr",
	"col4": "pages-help-__slug-indexstyleGrid-col4-bhnjv",
	"col9": "pages-help-__slug-indexstyleGrid-col9-treia",
	"col12": "pages-help-__slug-indexstyleGrid-col12-bruyl",
	"alignItemsStart": "pages-help-__slug-indexstyleGrid-alignItemsStart-bgrud"
};
module.exports = ___CSS_LOADER_EXPORT___;
